<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="book-i">
<div class="section level2" id="section-5">
<h1>6</h1>
<div class="section level3" id="cornwall-england">
<h3>Cornwall, England</h3>
<p>Eagle’s Croft is a modernised Jacobean house with panoramic views over Crantock Beach. A contemporary hillside monolith on one side, red-brick manor house on the other, it has the unique characteristic of overlooking both the Celtic Sea and Gannel Estuary. A small fortune has been spent bringing the original building into the twenty first century but it’s the glass-fronted extension where Lewis Bridges spends most of his time. From there he can see the boats bobbing on the waves in their hunt for sardines, and the tourist boats approaching directly behind on the Gannel. A mossy slope from the double glass doors leads to a winding path down to a boathouse on the beach with a heavy iron gate. The whole property is encircled by a six-foot perimeter fence with motion-sensor floodlights at regular intervals. The CCTV cameras are placed so as to be visible to the trained eye, but not obvious.</p>
<p>Bridges asks for, and receives, no visitors.</p>
<p>The single-room extension is German designed: minimalist open plan; three tall, white walls with bright splashes of modern art lit by down-lighters; polished marble floor. The fourth wall, overlooking the bay, is double-height glass and runs floor to ceiling. Furniture is sparse. There’s a white gloss kitchen that looks like it’s never been used, a few bits of gym equipment, a table with a bank of monitors, and a black leather Barcelona chair and stool overlooking the beach.</p>
<p>This is where Bridges sits, nursing his third coffee of the day, skim-reading the news on his iPad while Owen Twill is fingering a business card in a pub with sticky carpets three hundred miles away.</p>
<p>Nothing in the news interests him. Another war. Another political scandal. He swipes from one page to the next, paying scant attention beyond the headlines. An alert buzzes from the panel of monitors and he puts down his coffee and saunters over. He pushes a button and an LED stops flashing above one of the screens. It shows a postal van trundling past.</p>
<p>He walks back to the glass wall that separates him from the elements, picking up his coffee on the way. A glance at his watch confirms it’s after three and he swears under his breath. To kill time, he climbs onto an exercise bike and begins pedalling. He might be closer to seventy than sixty but he retains a sinewy athleticism—the result of a lifetime of training.</p>
<p>Just when he’s picked up speed the pealing bells of his phone ricochet off the high ceiling. He hops off the bike, takes glasses from his cardigan pocket and slips them on the end of his nose. He clears his throat and picks up the phone.</p>
<p>There’s background noise. Chatter and some laughter.</p>
<p>‘Yes?’</p>
<p>‘It’s on.’</p>
<p>‘When?’</p>
<p>‘Not yet. I’ll let you know.’</p>
<p>There’s a click. The line goes dead.</p>
<p>Lewis Bridges puts the phone down on the kitchen counter and looks out to sea.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0013.vue?390c8d04